/* istanbul ignore file */
import { TextField, FieldProps, useFieldHelper } from 'framework/ui/field';
import { useArtifactService } from 'domain/shared/artifact';
import { AttachmentFieldLayout } from 'domain/shared/artifact/field';
import { ArtifactType } from '../../artifactStorageService';
import { Box } from '@mui/material';

const ArtifactStorageTypeIcon = ({ fileSource, valueType, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper(props);
  const { getValue: getFile } = useFieldHelper({ source: fileSource || 'file.artifact' });
  const artifact = getFile() as any;
  const type = valueType || getValue();
  const { getThumbnail } = useArtifactService();

  const icon =
    type === ArtifactType.FOLDER ? (
      <Box component="i" className="fa fa-folder-o" sx={{ fontSize: '19px', color: 'text.secondary' }} />
    ) : (
      <AttachmentFieldLayout
        value={{ ...artifact, hasPreview: true, id: artifact.type === 'image' ? artifact.id : `file-${artifact.id}` }}
        getThumbnail={getThumbnail}
        isDownloadAvailable={false}
      />
    );

  return (
    <Box
      sx={{
        ...(type !== ArtifactType.FOLDER && { height: '24px' }),
        '& button': {
          padding: 0,
          margin: 0,
          background: 'transparent',
          border: 0,
          '& .files-list__files-image, & .files-list__files-icon': {
            width: '24px',
            height: '24px',
            display: 'block',
            margin: 0,
            position: 'relative',
            overflow: 'hidden',
            minWidth: '24px',
            '& img': {
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            },
          },
          '& .files-list__files-icon img': { width: '36px', height: '36px' },
          '& .files-list__files-name, & .files-list__files-type': { display: 'none' },
        },
      }}
    >
      <TextField {...props} value={icon} />
    </Box>
  );
};

export default ArtifactStorageTypeIcon;
